export const EA_PATH = '/expert-advice';

export const EA_PATH_TOPIC = `${EA_PATH}/topic`;

export const EXPERT_ADVICE_META_IMAGE =
  'https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/preauth/zola-expert-advice-meta.jpg';
